


import { SvgIcon, SvgIconProps } from "@mui/material";

export const RobotFaceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-width="1.5"
        d="M14.707 4.314H9.293a4.981 4.981 0 0 0-4.982 4.98v5.412a4.982 4.982 0 0 0 4.982 4.983h5.412a4.982 4.982 0 0 0 4.983-4.982V9.293a4.982 4.982 0 0 0-4.982-4.982v.002Z"
      />
      <path
        stroke="currentColor"
        stroke-width="1.5"
        d="M19.608 15.59h1.619a1.025 1.025 0 0 0 1.025-1.026V9.44a1.025 1.025 0 0 0-1.025-1.025h-1.62M4.397 15.59h-1.62a1.023 1.023 0 0 1-1.025-1.025V9.44a1.025 1.025 0 0 1 1.025-1.025h1.62"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M2.766 8.414v-4.1m18.46 4.1-.01-4.1m-12.3 4.45v2.698m6.15-2.698v2.698M9.94 15.589h4.1"
      />
    </svg>
  </SvgIcon>
);
